
import { useState, useEffect, ComponentProps } from 'react';
import { inject, observer } from 'mobx-react';
import { statusReferenceActions, StatusReferenceStore } from 'modules/statuses/store/statusReferenceStore';
import { SelectInput } from '../forms';

import { universalReferenceActions } from '../../../universal-reference/store/universalReferenceStore';

interface StatusSelectorProps extends ComponentProps<typeof SelectInput> {
    statusReferenceStore?: StatusReferenceStore,
    serviceId: number,
    excludedValues?: Array<number>,
    addId?: number,
    onlyOrderStatuses ?: boolean, // показывать только статусы из Order Status Controller (привязанные к заявкам и source - 144)
  }

const StatusSelector = (props: StatusSelectorProps) => {
  const {
    statusReferenceStore,
    excludedValues,
    serviceId,
    addId,
    onlyOrderStatuses,
    ...rest
  } = props;

  const { statuses } = statusReferenceStore;
  const [values, setValues] = useState([]);

  const addName: string = addId ? values.find((v) => v.id === addId)?.name : '';
  const toAdd = addId ? [{ id: addId, name: addName }] : [];

  const mappedValues = statuses.map((v) => { return {
    id: v.userStatusId,
    name: v.userStatusName,
    color: v.userStatusColor ?? undefined,
  }; });
  const filteredValues = onlyOrderStatuses
    ? mappedValues.filter((v) => (!(excludedValues ?? []).includes(v.id)))
    : values.filter((v) => (!(excludedValues ?? []).includes(v.id)));

  const valuesForSelector = filteredValues.find((v) => v.id === addId) ? filteredValues : [...filteredValues, ...toAdd];

  const [loading, setLoading] = useState(false);

  const loadData = async () => {
    setLoading(true);

    try {
      // статусы (справочник 9) идут из кэша стора universal-reference на сессию
      await universalReferenceActions.getRefValues(9)
        .then((refValues) => setValues(refValues));

      if (onlyOrderStatuses) {
        await statusReferenceActions.getStatusReferenceList(
          {
            serviceId,
            sourceRefValueId: 144,
          }
        );
      }
    } finally { setLoading(false); }
  };

  useEffect(() => {
    loadData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serviceId]);

  return (
    <SelectInput
      { ...rest }
      data={ valuesForSelector }
      dataTitle='name'
      dataValue='id'
      loading={ loading }
      sort
    />
  );
};

export default inject('statusReferenceStore')(observer(StatusSelector));
